import { users } from '../recs/engine';
import { UserProfile } from './types';

export interface Persona {
  user: UserProfile;
  archetype: string;
  blurb: string;
}

// A curated, diverse slice of the 70 sample profiles for the switcher — spans every
// preferred_language, both access tiers, and a spread of ages/behaviors so switching
// users visibly changes the recommendation rows.
const CURATED_IDS: { id: string; archetype: string; blurb: string }[] = [
  { id: 'MU2013', archetype: 'The Family Room', blurb: 'Mandarin · Free · 35-44 · Kids content' },
  { id: 'MU2000', archetype: 'The Occasional Viewer', blurb: 'Tamil · Free · 55+ · light history (cold-start)' },
  { id: 'MU2016', archetype: 'The Sports Fan', blurb: 'Mandarin · Premium · 18-24' },
  { id: 'MU2027', archetype: 'The Live TV Loyalist', blurb: 'English · Premium · 55+ · heavy live viewing' },
  { id: 'MU2035', archetype: 'The Drama Devotee', blurb: 'English · Free · 45-54 · Romance-leaning' },
  { id: 'MU2042', archetype: 'The Late-Night Binger', blurb: 'English · Free · 18-24 · Thriller-leaning' },
  { id: 'MU2057', archetype: 'The Completionist', blurb: 'Malay · Premium · 25-34 · finishes what she starts' },
  { id: 'MU2068', archetype: 'The Watchlist Hoarder', blurb: 'English · Free · 13-17 · saves everything' },
];

const userById = new Map(users.map((u) => [u.user_id, u]));

export const personas: Persona[] = CURATED_IDS.map(({ id, archetype, blurb }) => {
  const user = userById.get(id);
  if (!user) throw new Error(`Persona user ${id} not found in dataset`);
  return { user, archetype, blurb };
});
